import { getCookie } from '../application/helpers/cookies.ts'

const requestHeaders: HeadersInit | undefined = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'X-XSRF-Token': getCookie('XSRF-TOKEN')
}

export enum Method {
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE'
}

export class HttpService {
  // Using HTTP Methods for RESTful Services
  // GET / READ
  get(url: string) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: requestHeaders
    }).then((response: Response) => {
      if (response.status === 401 || response.status === 403) {
        // When Unauthorized, we reload to ge to the login screen
        window.location.reload()
      }
      else if (response.ok && response.status === 200) {
        return response.json()
      }
      else {
        return Promise.reject(response)
      }
    }).catch(error => console.error('get failed, error:', error))
  }
  // POST / CREATE
  post(url: string, data: any) {
    return this._update(url, data, Method.POST)
  }
  // PUT / UPDATE/REPLACE
  put(url: string, data: any) {
    return this._update(url, data, Method.PUT)
  }
  // DELETE / delete
  delete (url: string, data: any) {
    return this._update(url, data, Method.DELETE)
  }
  // PUT + POST + DELETE
  async _update(url: string, data: any, method: Method) {
    // console.log('HTTPSERVICE DATA: ', JSON.stringify(data), data)
    return fetch(url, {
      method: method.toString(),
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: requestHeaders
    }).then(response => {
      if (response.status === 401 || response.status === 403) {
        // When Unauthorized, we reload to ge to the login screen
        window.location.reload()
      }
      else if (response.ok && response.status === 200) {
        const contentType = response.headers.get("content-type")
        if (contentType && contentType.indexOf("application/json") !== -1)
          return response.json()
        else
          return response
      }
      else {
        return Promise.reject(response)
      }
    }).catch(error => console.error('Update failed, error:', error))
  }
  async _postParams(url: string, params: any) {
    // Add POST method possiblity to add parameters from an object
    return fetch(`${url}?${new URLSearchParams(params).toString()}`, {
      method: Method.POST,
      credentials: 'same-origin',
      headers: requestHeaders
    }).then(response => {
      if (response.status === 401 || response.status === 403) {
        // When Unauthorized, we reload to ge to the login screen
        window.location.reload()
      }
      else if (response.ok && response.status === 200) {
        // return response.json()
      }
      else {
        return Promise.reject(response)
      }
    }).catch(error => console.error('Update failed, error:', error))
  }
}

export const httpService = new HttpService()
